import { TextField as CssModulesTextField, TextFieldProps } from '@sunwebgroup/uds-ui/fields/text-field'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/fields/text-field' instead.
 */
export default Object.assign(
  styled(CssModulesTextField)<TextFieldProps>``,
  { displayName: 'TextField' },
)
